<template>
  <div class="backend-export">
    <section class="top-wrap">
      <div class="main-title">导出模板</div>
      <div class="right">
        <div class="mRight10">
          <el-input
            v-model="searchText"
            size="small"
            placeholder="搜索导出模板"
            clearable
            @keyup.native.enter="search"
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
        <el-button type="primary" size="small" @click="openExcelTplDialog(null)">新建</el-button>
      </div>
    </section>
    <section class="main-wrap">
      <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
      <BaseTable
        v-else
        ref="BaseTable"
        :tableHeight="tableHeight"
        :tableColumns="tableColumns"
        :tableData="filterData"
        :pageInfo="pageInfo"
        from="app"
      >
        <template v-slot:table-suffix>
          <el-table-column prop="handle" label="操作" width="160">
            <template v-slot="scope">
              <el-button @click.stop="openExcelTplDialog(scope.row)" type="text" size="mini">
                编辑
              </el-button>
              <el-button @click.stop="handleDelete(scope.row)" type="text" size="mini">
                删除
              </el-button>
            </template>
          </el-table-column>
        </template>
      </BaseTable>
    </section>
    <!-- 新建或编辑Excel导出模板 -->
    <ExcelTplDialog
      ref="excelTplDialog"
      :availableSheetsMap="availableSheetsMap"
      @openAllFiles="openAllFiles"
      @createTemplate="createTemplate"
      @editTemplate="editTemplate"
    ></ExcelTplDialog>
    <!-- 所有文件(excel) -->
    <AllFilesDialog
      :dialogVisible.sync="allFilesVisible"
      :defaultFileId="defaultFileId"
      search=".xls"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      @submit="selectFile"
    ></AllFilesDialog>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import TableControler from "@/views/Backend/Admin/Layout/mixin/TableController"
import AllFilesDialog from "@/components/AllFilesDialog"
import ExcelTplDialog from "./excelTplDialog"
import * as exportApi from "@/api/appManage/excel-template"
import { tableColumns } from "./static"
import { loadingService } from "@/utils/ui"
import { getAvailableSheets } from "@/api/sheet/sheet"

export default {
  name: "backend-export",
  components: {
    BaseTable,
    AllFilesDialog,
    ExcelTplDialog
  },
  inject: ["app"],
  data() {
    return {
      tableColumns,
      exportList: [],
      filterData: [],
      filterKeys: ["name"],
      pageInfo: {
        total: 1000,
        currentPage: 1,
        pageSize: 20
      },
      searchText: "",
      loadingItems: {
        data: true
      },
      availableSheets: [],
      editExcelTpl: null,
      allFilesVisible: false,
      defaultFileId: ""
    }
  },
  computed: {
    availableSheetsMap() {
      let availableSheetsMap = {}
      if (this.availableSheets.length == 0) return availableSheetsMap
      for (let app of this.availableSheets) {
        app.sheets.forEach(sheet => {
          availableSheetsMap[sheet.sheetId] = sheet
        })
      }
      return availableSheetsMap
    }
  },
  mixins: [TableControler],
  created() {
    this.refresh()
    getAvailableSheets({ appId: this.app.id }).then(data => {
      this.availableSheets = data
    })
  },
  methods: {
    refresh() {
      this.loadingItems.data = true
      exportApi.getExcelTemplateList(this.app.id).then(exportList => {
        this.exportList = exportList
        this.loadingItems.data = false
        this.filterData = this.exportList
        this.resetPageInfo(this.filterData)
      })
    },
    // 新建或编辑模板 row存在时是编辑，不存在时是新建
    openExcelTplDialog(row) {
      if (row) this.editExcelTpl = row
      else this.editExcelTpl = null
      this.$refs.excelTplDialog.open(this.editExcelTpl)
    },
    search() {
      this.handleSearch({
        tableData: this.exportList,
        filterKeys: this.filterKeys,
        searchText: this.searchText
      })
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除该导出模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        exportApi.deleteExcelTemplate(row.id).then(() => {
          this.refresh()
          this.$message.success("刪除成功")
        })
      })
    },
    // 打开选择文件dialog
    openAllFiles(fileId) {
      this.allFilesVisible = true
      this.defaultFileId = fileId
    },
    // 创建打印模板
    createTemplate(excelTemplate) {
      let loadingInstance = loadingService({ text: "新建中..." })
      exportApi
        .createExcelTemplate(excelTemplate, this.app.id)
        .then(() => this.refresh())
        .catch(err => this.$message.error("创建失败，请刷新后重试！"))
        .finally(() => loadingInstance.close())
    },
    // 编辑打印模板
    editTemplate(excelTemplate) {
      let loadingInstance = loadingService({ text: "保存中..." })
      exportApi
        .updateExcelTemplate(excelTemplate)
        .then(() => this.refresh())
        .catch(err => this.$message.error("保存失败，请刷新后重试！"))
        .finally(() => loadingInstance.close())
    },
    selectFile(file) {
      this.$refs.excelTplDialog.selectFile(file)
    }
  }
}
</script>

<style lang="scss" scoped>
.backend-export {
  .empty {
    height: 100%;
    width: 100%;
  }
  .right ::v-deep {
    .el-input-group__append {
      padding: 0 10px;
    }
  }
}
</style>
